import { render } from "./BaseDisabledTextarea.vue?vue&type=template&id=1db655c2&scoped=true"
import script from "./BaseDisabledTextarea.vue?vue&type=script&lang=js"
export * from "./BaseDisabledTextarea.vue?vue&type=script&lang=js"

import "./BaseDisabledTextarea.vue?vue&type=style&index=0&id=1db655c2&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db655c2"]])

export default __exports__